import React, { useState } from "react"
import { useParams } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import UknowFormModal from "./uknowFormModal/uknowFormModal"
import {
  createKnowmixStepUknow,
  deleteKnowmixStepUknow,
  knowmixStepUknowsList,
  knowmixStepUknowsListClear,
  updateKnowmixStepUknow,
} from "../../../../../../library/store/actions/creators/uknowCreators"
import UknowDialog from "./uknowDialog/uknowDialog"
import useCreator from "../../../../../../hooks/useCreator"
import ListPage from "../../../../../../components/v2/layout/listPage/listPage"
import UknowCard from "../../../../../../components/v2/layout/cards/uknowCard"
import withErrorBoundary from "../../../../../../hocs/guards/withErrorBoundary"
import { stepsList as getStepsList } from "../../../../../../library/store/actions/creators/knowmixCreators"

const KnowmixSettingsStepKnowmeets = () => {
  const dispatch = useDispatch()
  const params = useParams()
  const creator = useCreator()

  const { stepsList } = useSelector(({ knowmix }) => knowmix)
  const { uknowsList, uknowsListEndReached } = useSelector(({ uknow }) => ({
    uknowsList: uknow.stepList,
    uknowsListEndReached: uknow.stepListEndReached,
  }))

  const [createdUknow, setCreatedUknow] = useState(null)
  const [isCreatedUknowDialogOpen, setIsCreatedUknowDialogOpen] =
    useState(false)

  const onCreateKnowmeet = async (data) =>
    await creator(createKnowmixStepUknow(data))
  const onEditKnowmeet = async (data) =>
    await creator(updateKnowmixStepUknow(data))
  const onDeleteKnowmeet = async (id) => {
    await creator(deleteKnowmixStepUknow({ id }))
    await creator(getStepsList({ id: parseInt(params.knowmixId) }))
  }

  return (
    <ListPage
      title={"Step Meets"}
      creationButtonTitle={"Create Meet"}
      noResultsLabel={"This step doesn't have Meets yet"}
      filter={{
        label: "Step",
        emptyLabel: "Select step",
        list: stepsList,
        ready: true,
        initialValue: !!stepsList.length && stepsList[0].id,
        required: true,
      }}
      getList={async ({ name, filterId: step_id, offset }) =>
        await dispatch(
          knowmixStepUknowsList({
            name: name || undefined,
            knowmix_id: parseInt(params.knowmixId),
            step_id,
            offset,
          })
        )
      }
      clearList={() => dispatch(knowmixStepUknowsListClear())}
      list={uknowsList}
      listEndReached={uknowsListEndReached}
      getListItemComponent={({
        item,
        openEditDialog,
        openDeletionDialog,
        openInfoDialog,
      }) => (
        <UknowCard
          uknow={item}
          openDeleteUknow={openDeletionDialog}
          openEditUknow={openEditDialog}
          openUknowInfo={openInfoDialog}
          key={item.id}
        />
      )}
      getFormDialogComponent={({ open, onClose, activeItem, filterId }) => {
        return (
          <UknowFormModal
            activeUknow={activeItem}
            edit={!!activeItem}
            handleClose={onClose}
            open={open}
            onSave={!activeItem ? onCreateKnowmeet : onEditKnowmeet}
            knowmixId={parseInt(params.knowmixId)}
            type={"step"}
            activeStep={filterId}
          />
        )
      }}
      getDeletionDialogComponent={{
        entityName: "Meet",
        onDelete: onDeleteKnowmeet,
      }}
      getInfoDialogComponent={({ open, onClose, activeItem }) => (
        <UknowDialog
          open={open}
          handleClose={onClose}
          activeUknow={activeItem}
          type={"step"}
        />
      )}
    />

    // {isCreatedUknowDialogOpen && (
    //   <UknowCreatedDialog
    //     uknow={createdUknow}
    //     open={isCreatedUknowDialogOpen}
    //     handleClose={() => setIsCreatedUknowDialogOpen(false)}
    //   />
    // )}
  )
}

export default withErrorBoundary(KnowmixSettingsStepKnowmeets)
